module.exports = [
  {
    type: 'item',
    isHeader: true,
    name: 'MAIN NAVIGATION'
  },
  {
    type: 'tree',
    icon: 'fa fa-dashboard',
    name: 'dashboard',
    permission: [0,1,2,3],
    items: [
      {
        type: 'item',
        icon: 'fa fa-user-circle',
        name: 'patient_list',
        permission: [0,1,2,3],
        router: {
          name: 'patient_list'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-tasks',
        name: 'task_list',
        permission: [0,1,2,3],
        router: {
          name: 'task_list'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-users',
        name: 'user_list',
        permission: [0,1,2],
        router: {
          name: 'user_list'
        }
      }
      
    ]
  },
  {
    type: 'tree',
    icon: 'fa fa-gift',
    name: 'ration',
    permission: [0,1,2],
    items: [
      {
        type: 'item',
        icon: 'fa fa-user-circle-o',
        name: 'distributor',
        permission: [0,1,2],
        router: {
          name: 'Distributor'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-life-ring',
        name: 'request',
        permission: [0,1,2],
        router: {
          name: 'RequestForRation'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-address-card',
        name: 'ration',
        permission: [0,1,2],
        router: {
          name: 'RationLog'
        }
      }
    ]
  },
  {
    type: 'tree',
    icon: 'fa fa-truck',
    name: 'transport_request',
    permission: [0,1,2],
    items: [
      {
        type: 'item',
        icon: 'fa fa-truck',
        name: 'vehicle',
        permission: [0,1,2],
        router: {
          name: 'TransportVehicle'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-list',
        name: 'transport',
        permission: [0,1,2],
        router: {
          name: 'TransportRequest'
        }
      }
    ]
  },
  {
    type: 'tree',
    icon: 'fa fa-bar-chart',
    name: 'reports',
    permission: [0,1,2],
    items: [
      {
        type: 'item',
        icon: 'fa fa-area-chart',
        name: 'patient_report',
        permission: [0,1,2],
        router: {
          name: 'PatientReport'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-bar-chart',
        name: 'location_report',
        permission: [0,1,2],
        router: {
          name: 'LocationReport'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-line-chart',
        name: 'hotline_report',
        permission: [0,1,2],
        router: {
          name: 'HotlineReport'
        }
      }
    ]
  },
  {
    type: 'tree',
    icon: 'fa fa-laptop',
    name: 'settings',
    permission: [0,1,2],
    items: [
      {
        type: 'item',
        icon: 'fa fa-stethoscope',
        name: 'medicines',
        permission: [0,1,2],
        router: {
          name: 'medicines'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-map-marker',
        name: 'location',
        permission: [0,1,2],
        router: {
          name: 'location'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-plus-circle',
        name: 'addlocation',
        permission: [0,1,2],
        router: {
          name: 'AddLocation'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/lib/slideMenuItems.js